import React, { lazy, Suspense } from "react";
import { SuspenseLoader } from "../../../assets/loaders";
const LazyComponent = lazy(() => import("./passpolicies"));

export default function Policies() {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
